import React from 'react';
import { compose, bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { FormattedMessage } from 'react-intl'
import Divider from '@material-ui/core/Divider';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import { withStyles } from '@material-ui/core/styles';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';

import clsx from 'clsx';
import NoticeIcon from '../../images/Notice.png';
import TradeIcon from '../../images/Trade.png';
import AdjustmentIcon from '../../images/Adjustment.png';
import ProfileIcon from '../../images/Profile.png';
import AdministrationIcon from '../../images/Administration.png';
import OtherIcon from '../../images/Other.png';
import { IdentityActions, AccountActions } from '../../store';

import { Popover } from '@material-ui/core';

const styles = theme => ({
    toolbar: theme.mixins.toolbar,
    logoContainer: {
        display: 'flex',
        height: 98,
        width: 209,
    },
    displayOnRole: {
        display: 'none'
    },
    listItem: {
        backgroundColor: 'unset',
        cursor: 'pointer',
        textDecoration: 'none',
    },
    listItemAvatar: {
        height: 24,
        width: 24,
        marginRight: 5,
    },
    subMenu: {
        width: 180,
    },
});

class MainMenu extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            anchorAdjustEl: null,
            anchorAdminEl: null,
            anchorOtherEl: null,
            noticeDisplay: false,            // お知らせ
            tradeDisplay: false,             // 取引履歴
            adjDisplay: false,               // 精算
            adjDownDisplay: false,           // 精算_ダウンロード
            adjConfDisplay: false,           // 精算_確認
          //adjFinanDisplay: false,          // 精算_金融機関
            adjBankDisplay: false,           // 精算_銀行精算
            adjCreditDisplay: false,         // 精算_クレジット精算
            adjFeeDisplay: false,            // 精算_手数料集計
            profileDisplay: false,           // プロフィール
            adminDisplay: false,             // 管理
            adminAcquirerDisplay: false,     // 管理(代表加盟店)
            adminMerchantDisplay: false,     // 管理(加盟店)
            adminShopDisplay: false,         // 管理(店舗)
            adminTermDisplay: false,         // 管理(端末)
            adminPointManageDisplay: false,  // 管理(ポイント)
            adminPointAggregaDisplay: false, // 管理(ポイント集計)
            adminFeeManageDisplay: false,    // 管理(手数料)
            adminAccountDisplay: false,      // 管理(アカウント)
            adminSalesDisplay: false         // 管理(販促物)
        };
    }

    componentDidMount() {
        this.initUsersList();
    }

    // ユーザ情報取得
    initUsersList() {
        this.props.getMe(this.props.token)
            .then(
                (data) => {
                    this.authority(data);
                },
                (err) => {
                    console.debug(err);
                }
            );
    }

    // 権限取得
    authority(_data) {

        if (_data == null) {
            return;
        }

        //console.log(_data);
        const auth = _data.permissions;
           
        this.setState({
            noticeDisplay: this.chkPri(auth.fid1_0),            // お知らせ
            tradeDisplay: this.chkPri(auth.fid2_0),             // 取引履歴
            adjDownDisplay: this.chkPri(auth.fid3_1),           // 精算_ダウンロード
            adjConfDisplay: this.chkPri(auth.fid3_2),           // 精算_確認
          //adjFinanDisplay: this.chkPri(auth.fid3_3),          // 精算_金融機関
            adjBankDisplay: this.chkPri(auth.fid3_3),           // 精算_銀行精算
            adjCreditDisplay: this.chkPri(auth.fid3_3),         // 精算_クレジット精算
            adjFeeDisplay: this.chkPri(auth.fid3_4),            // 精算_手数料集計
            // 精算
            adjDisplay: (this.chkPri(auth.fid3_1) || this.chkPri(auth.fid3_2) || this.chkPri(auth.fid3_3) || this.chkPri(auth.fid3_4)),
            profileDisplay: this.chkPri(auth.fid4_0),           // プロフィール
            adminAcquirerDisplay: this.chkPri(auth.fid5_1),     // 管理(代表加盟店)
            adminMerchantDisplay: this.chkPri(auth.fid5_2),     // 管理(加盟店)
            adminShopDisplay: this.chkPri(auth.fid5_3),         // 管理(店舗)
            adminTermDisplay: this.chkPri(auth.fid5_4),         // 管理(端末)
            // 2020.09.30 S.Aizawa ポイントは未対応  2021.01.11 S.Aizawa 復活
            //adminPointManageDisplay: this.chkPri(auth.fid5_5),  // 管理(ポイント)
            //adminPointAggregaDisplay: this.chkPri(auth.fid5_6), // 管理(ポイント集計)
            adminPointManageDisplay: this.chkPri(auth.fid5_5),  // 管理(ポイント)
            adminPointAggregaDisplay: this.chkPri(auth.fid5_6), // 管理(ポイント集計)
            adminFeeManageDisplay: this.chkPri(auth.fid5_7),    // 管理(手数料)
            adminAccountDisplay: this.chkPri(auth.fid5_8),      // 管理(アカウント)
            adminSalesDisplay: this.chkPri(auth.fid5_9),        // 管理(販促物)
            // 管理
            adminDisplay: (this.chkPri(auth.fid5_1) || this.chkPri(auth.fid5_2) || this.chkPri(auth.fid5_3) || this.chkPri(auth.fid5_4)
                || this.chkPri(auth.fid5_5) || this.chkPri(auth.fid5_6) || this.chkPri(auth.fid5_7) || this.chkPri(auth.fid5_8) || this.chkPri(auth.fid5_9))
        });
    }

    // 権限チェック
    chkPri(fid) {
        if (fid == null) return false;

        var pri = fid.value.value;

        if (pri == 1 || pri == 2 || pri == 3) {  // 1:読み取り,2:書き込み,3:読み書き
            return true;
        }

        return false;
    }

    //ログアウト
    logout() {
        // ログアウト時は、再ログイン時にTOPが表示されるように設定しておく
        this.props.history.push("/");
        this.props.logout(this.props.auth);
    }

    //精算のサブメニューを閉じる
    closeAdjustSubMenu() {
        this.setState({ anchorAdjustEl: null });
    }
    //管理のサブメニューを閉じる
    closeAdminSubMenu() {
        this.setState({ anchorAdminEl: null });
    }
    //その他のサブメニューを閉じる
    closeOtherSubMenu() {
        this.setState({ anchorOtherEl: null });
    }

    render() {
        const { classes } = this.props;
        const open = this.state.mouseOverButton || this.state.mouseOverMenu;

        //お知らせメニュー押下
        const onNoticeClick = () => {
            this.props.history.push("/notice");
        };

        //取引管理メニュー押下
        const onTradeClick = () => {
            this.props.history.push("/trade");
        };

        //精算メニュー押下
        const onAdjustClick = (event) => {
            //精算のサブメニューを開く
            this.setState({ anchorAdjustEl: event.currentTarget });
        };
        const onAdjustClose = () => {
            this.closeAdjustSubMenu();
        }
        //精算一覧メニュー押下
        const onListDownloadClick = () => {
            this.closeAdjustSubMenu();
            this.props.history.push("/adjustment/download");
        };
        //精算書確認メニュー押下
        const onConfirmPaymentClick = () => {
            this.closeAdjustSubMenu();
            this.props.history.push("/adjustment/confirm");
        };
       /* //金融関連メニュー押下
        const onFinancialClick = () => {
            this.closeAdjustSubMenu();
            this.props.history.push("/adjustment/financial");
        };*/
        //銀行精算メニュー押下
        const onBankPaymentClick = () => {
            this.closeAdjustSubMenu();
            this.props.history.push("/adjustment/bank");
        };
        //クレジット精算メニュー押下
        const onCreditPaymentClick = () => {
            this.closeAdjustSubMenu();
            this.props.history.push("/adjustment/credit");
        };
        //手数料一覧メニュー押下
        const onFeeListClick = () => {
            this.closeAdjustSubMenu();
            this.props.history.push("/adjustment/feeList");
        };

        //プロフィールメニュー押下
        const onProfileClick = () => {
            this.props.history.push("/profile");
        };

        //管理メニュー押下
        const onAdminClick = (event) => {
            //管理のサブメニューを開く
            this.setState({ anchorAdminEl: event.currentTarget });
        };
        const onAdminClose = () => {
            this.closeAdminSubMenu();
        }
        //代表加盟店メニュー押下
        const onAcquirerClick = () => {
            this.closeAdminSubMenu();
            this.props.history.push("/administration/acquirer");
        };
        //加盟店メニュー押下
        const onMerchantClick = () => {
            this.closeAdminSubMenu();
            this.props.history.push("/administration/merchant");
        };
        //店舗メニュー押下
        const onShopClick = () => {
            this.closeAdminSubMenu();
            this.props.history.push("/administration/shop");
        };
        //端末メニュー押下
        const onTerminalClick = () => {
            this.closeAdminSubMenu();
            this.props.history.push("/administration/terminal");
        };
        //ポイント管理メニュー押下
        const onPointManagementClick = () => {
            this.closeAdminSubMenu();
            this.props.history.push("/administration/pointManagement");
        };
        //ポイント集計メニュー押下
        const onPointAggregateClick = () => {
            this.closeAdminSubMenu();
            this.props.history.push("/administration/pointAggregate");
        };
        //手数料管理メニュー押下
        const onFeeManagementClick = () => {
            this.closeAdminSubMenu();
            this.props.history.push("/administration/feeManagement");
        };
        //アカウントメニュー押下
        const onAccountClick = () => {
            this.closeAdminSubMenu();
            this.props.history.push("/administration/account");
        };
        //販促物メニュー押下
        const onSalesPromotionClick = () => {
            this.closeAdminSubMenu();
            this.props.history.push("/administration/salesPromotion");
        };

        //その他のサブメニュー
        const onOtherClick = (event) => {
            //その他のサブメニューを開く
            this.setState({ anchorOtherEl: event.currentTarget });
        };
        const onOtherClose = () => {
            this.closeOtherSubMenu();
        }
        //利用規約メニュー押下
        const onTermsOfServiceClick = () => {
            this.closeOtherSubMenu();
            this.props.history.push("/other/termsOfService");
        };

        return (
            <div>
                <div className={classes.toolbar}>
                    <div className={classes.logoContainer}>
                        <img src="../images/Logo_Mini.png" alt="OKICA" />
                    </div>
                </div>
                <Divider />
                <List>
                    <ListItem button key="Notice" onClick={onNoticeClick} className={clsx({ [classes.displayOnRole]: !(this.state.noticeDisplay) })}>
                        <img src={NoticeIcon} className={classes.listItemAvatar} alt="Notice" />
                        <ListItemText><FormattedMessage id="Menu.Notice" /></ListItemText>
                    </ListItem>
                    <ListItem button key="Trade" onClick={onTradeClick} className={clsx({ [classes.displayOnRole]: !(this.state.tradeDisplay) })}>
                        <img src={TradeIcon} className={classes.listItemAvatar} alt="Trade" />
                        <ListItemText><FormattedMessage id="Menu.TradeManagement" /></ListItemText>
                    </ListItem>
                    <ListItem button key="Adjustment" aria-controls="adjust-menu" aria-haspopup="true" onClick={onAdjustClick} className={clsx({ [classes.displayOnRole]: !(this.state.adjDisplay) })}>
                        <img src={AdjustmentIcon} className={classes.listItemAvatar} alt="Adjustment" />
                        <ListItemText><FormattedMessage id="Menu.Adjustment" /></ListItemText>
                        <ArrowForwardIosIcon />
                    </ListItem>
                    <ListItem button key="Profile" onClick={onProfileClick} className={clsx({ [classes.displayOnRole]: !(this.state.profileDisplay) })}>
                        <img src={ProfileIcon} className={classes.listItemAvatar} alt="ProfileIcon" />
                        <ListItemText><FormattedMessage id="Menu.Profile" /></ListItemText>
                    </ListItem>
                    <ListItem button key="Administration" aria-controls="admin-menu" aria-haspopup="true" onClick={onAdminClick} className={clsx({ [classes.displayOnRole]: !(this.state.adminDisplay) })}>
                        <img src={AdministrationIcon} className={classes.listItemAvatar} alt="Administration" />
                        <ListItemText><FormattedMessage id="Menu.Administration" /></ListItemText>
                        <ArrowForwardIosIcon />
                    </ListItem>
                    <ListItem button key="Other" aria-controls="other-menu" aria-haspopup="true" onClick={onOtherClick}>
                        <img src={OtherIcon} className={classes.listItemAvatar} alt="Other" />
                        <ListItemText><FormattedMessage id="Menu.Other" /></ListItemText>
                        <ArrowForwardIosIcon />
                    </ListItem>
                </List>

                {/*  精算のサブメニュー */}
                <Popover
                    id="adjust-menu"
                    open={Boolean(this.state.anchorAdjustEl)}
                    anchorEl={this.state.anchorAdjustEl}
                    onClose={onAdjustClose}
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                    }}
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'left',
                    }}
                >
                    <List className={classes.subMenu}>
                        <ListItem button key="PayOffList" onClick={onListDownloadClick} className={clsx({ [classes.displayOnRole]: !(this.state.adjDownDisplay) })}>
                            <ListItemText><FormattedMessage id="Menu.ListDownload" /></ListItemText>
                        </ListItem>
                        <ListItem button key="ConfirmPayment" onClick={onConfirmPaymentClick} className={clsx({ [classes.displayOnRole]: !(this.state.adjConfDisplay) })}>
                            <ListItemText><FormattedMessage id="Menu.ConfirmPayment" /></ListItemText>
                        </ListItem>
                        {/* <ListItem button key="Financial" onClick={onFinancialClick} className={clsx({ [classes.displayOnRole]: !(this.state.adjFinanDisplay) })}>
                            <ListItemText><FormattedMessage id="Menu.Financial" /></ListItemText>
                        </ListItem>*/}
                        <ListItem button key="BankPayment" onClick={onBankPaymentClick} className={clsx({ [classes.displayOnRole]: !(this.state.adjBankDisplay) })}>
                            <ListItemText><FormattedMessage id="Menu.BankPayment" /></ListItemText>
                        </ListItem>
                        <ListItem button key="CreditPayment" onClick={onCreditPaymentClick} className={clsx({ [classes.displayOnRole]: !(this.state.adjCreditDisplay) })}>
                            <ListItemText><FormattedMessage id="Menu.CreditPayment" /></ListItemText>
                        </ListItem>
                        <ListItem button key="FeeList" onClick={onFeeListClick} className={clsx({ [classes.displayOnRole]: !(this.state.adjFeeDisplay) })}>
                            <ListItemText><FormattedMessage id="Menu.FeeList" /></ListItemText>
                        </ListItem>
                    </List>
                </Popover>

                {/*  管理のサブメニュー */}
                <Popover
                    id="admin-menu"
                    open={Boolean(this.state.anchorAdminEl)}
                    anchorEl={this.state.anchorAdminEl}
                    onClose={onAdminClose}
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                    }}
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'left',
                    }}
                >
                    <List className={classes.subMenu}>
                        <ListItem button key="Acquirer" onClick={onAcquirerClick} className={clsx({ [classes.displayOnRole]: !(this.state.adminAcquirerDisplay) })}>
                            <ListItemText><FormattedMessage id="Menu.Acquirer" /></ListItemText>
                        </ListItem>
                        <ListItem button key="Merchant" onClick={onMerchantClick} className={clsx({ [classes.displayOnRole]: !(this.state.adminMerchantDisplay) })}>
                            <ListItemText><FormattedMessage id="Menu.Merchant" /></ListItemText>
                        </ListItem>
                        <ListItem button key="Shop" onClick={onShopClick} className={clsx({ [classes.displayOnRole]: !(this.state.adminShopDisplay) })}>
                            <ListItemText><FormattedMessage id="Menu.Shop" /></ListItemText>
                        </ListItem>
                        <ListItem button key="Terminal" onClick={onTerminalClick} className={clsx({ [classes.displayOnRole]: !(this.state.adminTermDisplay) })}>
                            <ListItemText><FormattedMessage id="Menu.Terminal" /></ListItemText>
                        </ListItem>
                        <ListItem button key="PointManagement" onClick={onPointManagementClick} className={clsx({ [classes.displayOnRole]: !(this.state.adminPointManageDisplay) })}>
                            <ListItemText><FormattedMessage id="Menu.PointManagement" /></ListItemText>
                        </ListItem>
                        <ListItem button key="PointAggregate" onClick={onPointAggregateClick} className={clsx({ [classes.displayOnRole]: !(this.state.adminPointAggregaDisplay) })}>
                            <ListItemText><FormattedMessage id="Menu.PointAggregate" /></ListItemText>
                        </ListItem>
                        <ListItem button key="FeeManagement" onClick={onFeeManagementClick} className={clsx({ [classes.displayOnRole]: !(this.state.adminFeeManageDisplay) })}>
                            <ListItemText><FormattedMessage id="Menu.FeeManagement" /></ListItemText>
                        </ListItem>
                        <ListItem button key="Account" onClick={onAccountClick} className={clsx({ [classes.displayOnRole]: !(this.state.adminAccountDisplay) })}>
                            <ListItemText><FormattedMessage id="Menu.Account" /></ListItemText>
                        </ListItem>
                        <ListItem button key="SalesPromotion" onClick={onSalesPromotionClick} className={clsx({ [classes.displayOnRole]: !(this.state.adminSalesDisplay) })}>
                            <ListItemText><FormattedMessage id="Menu.SalesPromotion" /></ListItemText>
                        </ListItem>
                    </List>
                </Popover>

                {/*  その他のサブメニュー */}
                <Popover
                    id="other-menu"
                    open={Boolean(this.state.anchorOtherEl)}
                    anchorEl={this.state.anchorOtherEl}
                    onClose={onOtherClose}
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                    }}
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'left',
                    }}
                >
                    <List className={classes.subMenu}>
                        {/*  利用規約 */}
                        <ListItem button key="TermsOfService" onClick={onTermsOfServiceClick}>
                            <ListItemText><FormattedMessage id="Menu.TermsOfService" /></ListItemText>
                        </ListItem>
                        {/*  ログアウト */}
                        <ListItem button key="Logout" onClick={() => this.logout()}>
                            <ListItemText><FormattedMessage id="Menu.Logout" /></ListItemText>
                        </ListItem>
                    </List>
                </Popover>
            </div>
        )
    }
}

function mapStateToProps(state, ownProps) {
    return {
        token: state.Identity.token,
        userName: state.Identity.username,
        auth: state.Identity.auth
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(Object.assign({}, IdentityActions, AccountActions), dispatch)
}

export default compose(withStyles(styles, { withTheme: true }), withRouter, connect(
    mapStateToProps,
    mapDispatchToProps
))(MainMenu);
